module.exports = __webpack_public_path__ + "static/img/19012B_0_3_C_20220303_fit.e3091d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19012B_0_3_C_20220303_fit.png
// module id = YIRH
// module chunks = 0